export const SUPPLIER_COPY = {
	title: {
		add: 'Add supplier',
		edit: 'Edit supplier',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Capture the supplier details, risk, and quality coverage that matter for your safety program.',
	fields: {
		nameLabel: 'Which supplier or manufacturer are you documenting?',
		materialScopeLabel: 'What material or service do they provide?',
		materialScopeDescription:
			'Outline the ingredients, packaging components, lab work, or services they deliver.',
		riskLevelLabel: 'How would you rate their risk level?',
		riskLevelDescription:
			'High: sole-source actives, talc/tight tolerance testing labs, or contract manufacturers. Medium: primary packaging, secondary fillers, or labs with backups. Low: redundant suppliers or services that do not touch formulas or safety evidence.',
		qualityAgreementLabel:
			'Do you have a signed quality agreement with this supplier?',
		contactEmailLabel: 'Who is the primary contact email? (optional)',
	},
}

export const SUPPLIER_RISK_LEVEL_OPTIONS = [
	{ value: 'critical', label: 'Critical' },
	{ value: 'high', label: 'High' },
	{ value: 'medium', label: 'Medium' },
	{ value: 'low', label: 'Low' },
] as const
